module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/sash-window/texture.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/sash-window/texture.png
// module id = 489
// module chunks = 0